import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTimeDetailed'
})
export class SecondsToTimeDetailedPipe implements PipeTransform {

  transform(value: number): { value: number, unit: string } {
    if (value == null || isNaN(value)) {
      return { value: 0, unit: 'días' };
    }
    
    const days = Math.floor(value / 86400);
    const hours = Math.floor((value % 86400) / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    
    // Si hay días, mostrar días
    if (days > 0) {
      return { value: days, unit: days === 1 ? 'día' : 'días' };
    }
    
    // Si hay horas, mostrar horas
    if (hours > 0) {
      return { value: hours, unit: hours === 1 ? 'hora' : 'horas' };
    }
    
    // Si solo hay minutos, mostrar minutos
    return { value: minutes, unit: minutes === 1 ? 'minuto' : 'minutos' };
  }
}